function initFooterAccordions() {
  if (typeof window.Accordion === "undefined") {
    setTimeout(initFooterAccordions, 100);
    return;
  }

  const footerAccordions = document.querySelectorAll(
    ".footer--menu-accordion, .footer--submenu-accordion"
  );
  const accordionInstances = [];

  // Create accordion instances
  footerAccordions.forEach((el) => {
    const accordion = new window.Accordion(el);
    accordionInstances.push(accordion);
  });

  // Handle responsive behavior
  function updateAccordionState(isDesktop) {
    accordionInstances.forEach((accordion) => {
      if (isDesktop) {
        accordion.disable();
      } else {
        accordion.enable();
        // Always start closed on mobile
        accordion.close();
      }
    });
  }

  // Check initial state
  const mediaQuery = window.matchMedia("(min-width: 768px)");
  updateAccordionState(mediaQuery.matches);

  // Listen to global breakpoint events
  window.addEventListener("breakpoint-md-up", (e) => {
    updateAccordionState(e.detail.matches);
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initFooterAccordions);
} else {
  initFooterAccordions();
}
